import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'vue-nprogress'
import AuthService from './services/auth'
import axiosInstance from './services/api-client/axiosClient'
import axios from 'axios'
import { i18n } from '@/localization'
import VueLayers from 'vuelayers'
import BootstrapVue from 'bootstrap-vue'

import VueFormulate from '@braid/vue-formulate'
import VueCurrencyFilter from 'vue-currency-filter'
import moment from 'moment'
import 'moment/locale/nl'
import {
  Avatar, TreeSelect, Rate, Breadcrumb, InputNumber, Steps, Message,
  Upload, Button, Layout, Table, Icon, Progress, Radio, Dropdown, Menu,
  Carousel, Input, Calendar, Badge, Slider, Form, Tooltip, Select, Switch,
  Tag, Affix, Spin, Alert, Checkbox, Tabs, Pagination, notification, Drawer,
  Cascader, DatePicker, TimePicker, Divider, Anchor, AutoComplete, BackTop, Collapse, Card, List, Popover,
  Tree, Timeline, Row, Col, Transfer, Modal, message, Popconfirm, Skeleton, LocaleProvider,
} from 'ant-design-vue'

import './global.scss'

import VueTimepicker from 'vue2-timepicker'

import Multiselect from 'vue-multiselect'

import Vcalendar from 'v-calendar'

Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(Skeleton)
Vue.use(Avatar)
Vue.use(Popconfirm)
Vue.use(Transfer)
Vue.use(Modal)
Vue.use(Divider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Timeline)
Vue.use(Tree)
Vue.use(Popover)
Vue.use(List)
Vue.use(Card)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Anchor)
Vue.use(AutoComplete)
Vue.use(Collapse)
Vue.use(BackTop)
Vue.use(LocaleProvider)

// let axiosInstance = axios.create({
//   baseURL: process.env.VUE_APP_API_URL,
//   // baseURL: 'http://127.0.0.1:8000/api',
//   /* other custom settings */
// })

Vue.prototype.$axios = axiosInstance()
Vue.prototype.$notification = notification
Vue.prototype.$message = message
Vue.prototype.moment = moment
Vue.prototype.$moment = moment
moment.locale('nl')

Vue.use(VueFormulate)
Vue.use(VueCurrencyFilter,
  {
    symbol: '€',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true,
  })
Vue.component('vue-timepicker', VueTimepicker)
Vue.component('multiselect', Multiselect)
Vue.use(Vcalendar)

Vue.use(NProgress)
Vue.use(AuthService)
Vue.use(VuePageTitle, {
  prefix: 'Royal Parking Admin | ',
  router,
})

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  nprogress,
  i18n,
  render: h => h(App),
}).$mount('#app')
